export default __webpack_public_path__ + "media/images/hometown-icon-eda3261a86f41884e52fba82e0544c44.svg";